<template>
	<div class="wzry_content">
		<div class="wzry_form">
			<a class="logo" href="https://m.xubei.com/"><img src="/static/images/logo.png" /></a>
			<div class="rankTab">
				<div
					class="item"
					:class="{ active: currentType == item.currentType }"
					v-for="(item, index) in gameList"
					@click="selectGame(item.currentType)"
				>
					<span>{{ item.text }}</span>
				</div>
			</div>

			<table class="rankTable">
				<tr>
					<th>排行</th>
					<th>角色</th>
					<th>价值</th>
					<th>试玩</th>
				</tr>
				<tr class="tr1" v-for="(item, index) in gameAll">
					<td class="sort">{{ index + 1 }}</td>
					<td class="role">{{ item.properties.role }}</td>
					<td class="price">{{ item.properties.price }}</td>
					<td class="swBtn"><a :href="item.properties.url">试玩</a></td>
				</tr>
			</table>
		</div>

		<div class="ftBtn">
			<a :href="'/publish'" class="btn1"><img src="/static/images/swBtn.png" /></a>
			<a href="http://www.xubei.com/publishGoodsStepOne.htm" class="btn2"><img src="/static/images/fbczBtn.png" /></a>
		</div>
	</div>
</template>

<script>
import { Toast } from 'mint-ui';
import { PROXY_URL } from '../../config/env';
export default {
	name: 'home',
	components: { Toast },
	data: function () {
		return {
			currentType: 'wzry',
			gameList: [
				{ currentType: 'wzry', text: '王者荣耀' },
				{ currentType: 'yxlm', text: '英雄联盟' },
				{ currentType: 'dxcys', text: '地下城与勇士' },
				{ currentType: 'cyhx', text: '穿越火线' }
			],
			gameAll: []
		};
	},
	mounted() {
		this.selectGame('wzry');
		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});
	},
	methods: {
		selectGame: function (type) {
			this.currentType = type;
			this.ajax
				.get(PROXY_URL.config + '/xubei-page-cloud/anon/cms/getModDataByModId?modId=' + type)
				.then(res => {
					console.log(res);
					this.gameAll = res.data.result.datas;
				})
				.catch(error => {});
		}
	}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.wzry_content {
	width: 10rem;
	margin: 0 auto;
	height: 100%;
	background: #1f1715;
	background-size: 100% 100%;
	position: relative;
	.wzry_form {
		padding: px2rem(26rem) px2rem(30rem) 0 px2rem(30rem);
		.logo {
			padding-left: px2rem(20rem);
			display: block;
			img {
				width: px2rem(278rem);
				height: px2rem(52rem);
			}
		}
		.rankTab {
			background: #34271f;
			margin-top: px2rem(10rem);
			margin-bottom: px2rem(20rem);
			border-radius: px2rem(8rem);
			overflow: hidden;
			.item {
				float: left;
				width: 25%;
				text-align: center;
				font-size: px2rem(28rem);
				span {
					color: #ffddb5;
					height: px2rem(90rem);
					line-height: px2rem(90rem);
				}
			}
			.active {
				span {
					color: #fef266;
					border-bottom: 2px solid #ffffff;
					display: inline-block;
				}
			}
		}

		.rankTable {
			width: 100%;
			margin-bottom: px2rem(150rem);
			tr {
				text-align: center;
				th {
					color: #ffddb5;
					background: #2c201c;
					height: px2rem(70rem);
					line-height: px2rem(70rem);
					border-bottom: 1px solid #423733;
					opacity: 0.6;
				}
			}

			.tr1 {
				height: px2rem(100rem);
				font-size: px2rem(32rem);
				border-bottom: 1px solid #4c4343;
				.sort {
					color: #ffddb5;
				}
				.role {
					color: #ffddb5;
					width: px2rem(200rem);
				}
				.price {
					color: #ff8f45;
				}
				.swBtn {
					a {
						border: 1px solid #ffddb5;
						color: #ffddb5;
						border-radius: px2rem(25rem);
						background: transparent;
						font-size: px2rem(26rem);
						display: block;
						width: px2rem(102rem);
						height: px2rem(52rem);
						line-height: px2rem(52rem);
						margin: 0 auto;
					}
					a:active {
						background: #715e4c;
					}
				}
			}
			.tr1:nth-of-type(odd) {
				background: #2c201c;
			} /*奇数行*/
			.tr1:nth-of-type(even) {
				background: #34271f;
			} /*偶数行*/
		}
	}
	.ftBtn {
		width: 100%;
		height: px2rem(140rem);
		line-height: px2rem(140rem);
		background: #000;
		position: fixed;
		left: 0;
		bottom: 0;
		display: flex;
		padding: 0 px2rem(30rem) 0 px2rem(12rem);

		a {
			display: block;
		}
		.btn1 {
			flex: 1;
			img {
				width: px2rem(252rem);
				height: px2rem(105rem);
				vertical-align: middle;
			}
		}
		.btn2 {
			img {
				width: px2rem(436rem);
				height: px2rem(105rem);
				vertical-align: middle;
			}
		}
		img {
			margin-top: px2rem(-14rem);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/home/rank.vue